import get from "lodash/get"
import { connect } from "react-redux"
import { getRedesignedDashboardServicesDetails as getAllCustomerServices } from "actions-lib/getRedesignedDashboardServicesDetails"
import { setSelectedServiceObject } from "actions-lib/setSelectedServiceObject"
import { setDashboardServices } from "actions-lib/setDashboardServices"
import { setDashboardCustomerId } from "actions-lib/setDashboardCustomerId"
import { setDashboardServiceAddress } from "actions-lib/setDashboardServiceAddress"
import { isBrokerAccountSelector } from "selectors-lib/linkedAccounts"
import { getServletBrightEdge } from "actions-lib/getServletBightEdge"
import TopHeader from "./TopHeader"

const mapDispatchToProps = {
  getAllCustomerServices,
  setSelectedServiceObject,
  setDashboardServices,
  setDashboardCustomerId,
  setDashboardServiceAddress,
  getServletBrightEdge,
}

const mapStateToProps = (state) => ({
  customerSelections: state.customerSelections,
  incidents: get(state, `notifications.incidentsByDate`, []),
  notifications: get(state, `notifications.notifications`, []),
  userManageAccount: state.userManageAccount,
  myServices: state.myServices,
  isBrokerAccount: isBrokerAccountSelector(state),
  userAccount: state.userAccount,
  language: state.siteLanguage?.language,
  onlineProducts: state.onlineProducts,
})

export default connect(mapStateToProps, mapDispatchToProps)(TopHeader)
